// The different levels of language skills
export const languageSkillLevels = [
  {
    level: 5,
    label: "Muttersprache",
  },
  { level: 4, label: "Verhandlungssicher" },
  { level: 3, label: "Fließend" },
  { level: 2, label: "Gute Kenntnisse" },
  { level: 1, label: "Grundkenntnisse" },
];

// The different levels of IT skills
export const itSkillLevels = [
  { level: 1, label: "Grundkenntnisse" },
  { level: 2, label: "Fortgeschrittene Kenntnisse" },
  { level: 3, label: "Vertiefte Fachkenntnisse" },
];
